import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { NzMessageService } from 'ng-zorro-antd/message';

export const authGuardFn = () => {
  const router = inject(Router);
  const mess = inject(NzMessageService);
  const listRole = ['Dhx', 'Ktt', 'Opt', 'Admin'];
  let haveRole: boolean = false;
  const role: any[] = JSON.parse(
    localStorage.getItem('userInfor') || '[]'
  )?.roles;
  role?.forEach((e: any) => {
    if (listRole.includes(e)) {
      haveRole = true;
    }
  });
  if (
    !localStorage.getItem('userInfor') ||
    !localStorage.getItem('access_token')
  ) {
    localStorage.clear();
    router.navigate(['/login']);
    return false;
  }
  if (haveRole) {
    return true;
  }
  mess.error('Bạn không có quyền vào trang này');
  localStorage.clear();
  router.navigate(['/login']);
  return false;
};
